document.addEventListener('DOMContentLoaded', function () {
    flatpickr("#datepicker-rental", {
        dateFormat: "Y/m/d",
        locale: "ja",
        allowInput: true,
        minDate: "today",
        disableMobile: true
    });
});
